import { useLocation, useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ProfileMenu from "@/components/ProfileMenu";
import { planLabel } from "@/lib/useMerchant";

export default function DashboardHeader({ me }) {
  const location = useLocation();
  const navigate = useNavigate();
  const onDashboard = location.pathname === "/dashboard";

  // me.plan_meta?.name would be the "proper" source, but api-me's plan_meta
  // is currently always {} server-side — fall back to deriving the label
  // from the plan key itself so the badge never renders blank.
  const displayPlan = me?.plan_meta?.name || planLabel(me?.plan);

  return (
    <header className="border-b border-ink/10 bg-white/80 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-6 py-4 md:px-10">
        <Link to="/dashboard" className="flex min-w-0 items-center gap-3">
          <img src="/logo.png" alt="Checkout DM" className="h-10 w-10 flex-none rounded-2xl" />
          <div className="min-w-0">
            <p className="truncate font-display text-lg font-black tracking-tight">Checkout DM</p>
            <p className="hidden text-xs text-ink/60 sm:block">Merchant dashboard</p>
          </div>
        </Link>
        <div className="flex flex-none items-center gap-2 md:gap-3">
          {displayPlan && (
            <span
              data-testid="header-plan-badge"
              className="inline-flex flex-none items-center text-center rounded-full border border-ink/10 bg-white px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.1em] text-ink leading-tight whitespace-normal break-words max-w-[4.5rem] sm:max-w-none sm:whitespace-nowrap md:px-3 md:py-1 md:text-xs md:tracking-[0.15em]"
            >
              {displayPlan} plan
            </span>
          )}
          {me && <ProfileMenu me={me} />}
        </div>
      </div>
    </header>
  );
}